import { createToolStore } from './create-tool-store'

export const usePdfCompressorStore = createToolStore({ quality: 60 })
